import React, { useEffect, useRef, useState } from 'react';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

const useOutsideClick = (callback) => {
    const ref = useRef();
  
    const handleClick = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            callback();
        }
    };
  
    useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
        //eslint-disable-next-line
    }, [callback]);
  
    return ref;
};

const EmojiPicker = ({ inputRef, value, setValue }) => {
    const [showPicker, setShowPicker] = useState(false);
    const [cursorPosition, setCursorPosition] = useState(0);

    const emojiPicker = useOutsideClick(() => {
        setShowPicker(false);
    });

    const handleInsertEmoji = (emoji) => {
        const updatedValue =
            value.substring(0, cursorPosition) +
            emoji.native + " " +
            value.substring(cursorPosition);

        setValue(updatedValue);
        setShowPicker(false);
        setTimeout(() => {
            inputRef.current.focus();
            inputRef.current.selectionStart = inputRef.current.selectionEnd = cursorPosition + emoji.native.length + 1;
        },100)
    }
    
    const handleShowPicker = () => {
        setShowPicker(true);
        if (inputRef.current) {
            setCursorPosition(inputRef.current.selectionStart);
        }else{
            setCursorPosition(value.length);
        }
    }

    return (
        <>
             <button type='button' className="hover:text-primary" onClick={handleShowPicker}>
                <svg width="19" height="18" viewBox="0 0 19 18" className="fill-current"><path fillRule="evenodd" clipRule="evenodd" d="M9.5 2.25C5.77208 2.25 2.75 5.27208 2.75 9C2.75 12.7279 5.77208 15.75 9.5 15.75C13.2279 15.75 16.25 12.7279 16.25 9C16.25 5.27208 13.2279 2.25 9.5 2.25ZM1.25 9C1.25 4.44365 4.94365 0.75 9.5 0.75C14.0564 0.75 17.75 4.44365 17.75 9C17.75 13.5564 14.0564 17.25 9.5 17.25C4.94365 17.25 1.25 13.5564 1.25 9Z"></path><path fillRule="evenodd" clipRule="evenodd" d="M7.09769 10.0469C6.84856 9.71825 6.38037 9.6523 6.05004 9.90004C5.71867 10.1486 5.65152 10.6187 5.90004 10.95L6.50004 10.5C5.90004 10.95 5.90022 10.9503 5.90041 10.9505L5.9008 10.9511L5.90167 10.9522L5.90372 10.9549L5.90913 10.962L5.9251 10.9824C5.93803 10.9988 5.95555 11.0204 5.97757 11.0467C6.02155 11.0991 6.08379 11.17 6.16363 11.2533C6.32269 11.4193 6.55512 11.6379 6.85579 11.8566C7.45424 12.2918 8.3559 12.75 9.50004 12.75C10.6442 12.75 11.5458 12.2918 12.1443 11.8566C12.445 11.6379 12.6774 11.4193 12.8365 11.2533C12.9163 11.17 12.9785 11.0991 13.0225 11.0467C13.0445 11.0204 13.0621 10.9988 13.075 10.9824L13.091 10.962L13.0964 10.9549L13.0984 10.9522L13.0993 10.9511L13.0997 10.9505C13.0999 10.9503 13.1 10.95 12.5 10.5L13.1 10.95C13.3486 10.6187 13.2814 10.1486 12.95 9.90004C12.6197 9.6523 12.1515 9.71825 11.9024 10.0469L11.8989 10.0514C11.8945 10.057 11.886 10.0676 11.8736 10.0823C11.8487 10.112 11.8084 10.1582 11.7535 10.2155C11.643 10.3308 11.477 10.4872 11.262 10.6435C10.8292 10.9583 10.2309 11.25 9.50004 11.25C8.76919 11.25 8.17084 10.9583 7.73805 10.6435C7.52309 10.4872 7.35709 10.3308 7.24661 10.2155C7.19168 10.1582 7.15139 10.112 7.12653 10.0823C7.11412 10.0676 7.10563 10.057 7.10117 10.0514L7.09769 10.0469Z"></path><path fillRule="evenodd" clipRule="evenodd" d="M6.5 6.75C6.5 6.33579 6.83579 6 7.25 6H7.2575C7.67171 6 8.0075 6.33579 8.0075 6.75C8.0075 7.16421 7.67171 7.5 7.2575 7.5H7.25C6.83579 7.5 6.5 7.16421 6.5 6.75Z"></path><path fillRule="evenodd" clipRule="evenodd" d="M11 6.75C11 6.33579 11.3358 6 11.75 6H11.7575C12.1717 6 12.5075 6.33579 12.5075 6.75C12.5075 7.16421 12.1717 7.5 11.7575 7.5H11.75C11.3358 7.5 11 7.16421 11 6.75Z"></path></svg>
            </button>
            {
                showPicker && 
                <div className='absolute bottom-0 translate-x-1/3' ref={emojiPicker}>
                    <Picker data={data} onEmojiSelect={handleInsertEmoji} />
                </div>
            }
        </>
    )
}

export default EmojiPicker